import { EntityState } from '@ngrx/entity';
import { Device } from '@app/resources/services';

export interface DeviceState extends EntityState<Device> {
  selectedDeviceId: number | null;
  hasLoaded: boolean;
}
